import script from "./MoneyReceiptSatementReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyReceiptSatementReportTable.vue?vue&type=script&setup=true&lang=js"

import "./MoneyReceiptSatementReportTable.vue?vue&type=style&index=0&id=6367b75f&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6367b75f"]])

export default __exports__